import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import styled, { css } from 'styled-components';
import { routes } from '@constants';

const SECTIONS = [
  { label: 'Menu', path: routes.menu, match: '/menu' },
  { label: 'Schedule', path: routes.scheduling, match: '/scheduling' },
  { label: 'Bookings', path: routes.reservations, match: '/reservations' },
];

const SectionNav = () => {
  const history = useHistory();
  const { pathname } = useLocation();

  return (
    <Wrapper>
      {SECTIONS.map(({ label, path, match }) => (
        <Tab
          key={label}
          isActive={pathname.startsWith(match)}
          onClick={() => history.push(path)}
        >
          {label}
        </Tab>
      ))}
    </Wrapper>
  );
};

const Wrapper = styled.nav`
  display: flex;
  align-items: center;
  background-color: #ffffff;
  border-bottom: 1px solid #f0f0f0;
  position: sticky;
  top: 0;
  z-index: 100;
  height: 44px;
  padding: 0 12px;
`;

const Tab = styled.button`
  ${({ isActive, theme: { color } }) => css`
    background: none;
    border: none;
    cursor: pointer;
    font-size: 14px;
    font-weight: 600;
    padding: 0 16px;
    height: 100%;
    color: ${isActive ? color.strawberry : color.warmGrey};
    border-bottom: 2px solid ${isActive ? color.strawberry : 'transparent'};
    transition: color 0.15s, border-color 0.15s;

    &:hover {
      color: ${color.strawberry};
    }
  `}
`;

export default SectionNav;
